<template lang="pug">
include ProfileVCardAppearance.pug
</template>

<script>
import { first } from 'underscore'
import ColorBox from '@/components/vcard/ColorBox'
import { mapState } from 'vuex'
import Api from './services/Api'

export default {
  name: 'ProfileVCardAppearance',
  components: {
    ColorBox,
  },
  props: ['id'],
  data() {
    return {
      bio: '',
      title: '',
      loaded: false,
      me: null,
      slug: null,
      vcard: null,
      colors: [
        ['#891b5d', '#63d5c5'],
        ['#891b5d', '#891b5d'],
        ['#176999', '#176999'],
        ['#891b5d', '#176999'],
      ],
      selectedColor: null,
    }
  },
  watch: {
    async title(newValue) {
      await Api.updateVcard(this.slug, { vcard_title: newValue }, this.token)
    },
    async bio(newValue) {
      await Api.updateVcard(this.slug, { vcard_bio: newValue }, this.token)
    },
  },
  computed: {
    ...mapState(['token']),
    currentUrl: function () {
      return first(window.location.href.split('#'))
    },
    avatarAction: function () {
      return `${Api.getApiUrl()}/esreps/vcard-avatar-update/`
    },
  },
  async created() {
    const _this = this

    await this.refreshMe()
    const vcardResponse = await Api.getVcard(this.slug)
    const vcard = vcardResponse.data
    const allowed = vcard.allowed

    if (!allowed) {
      this.$router.push({
        name: 'TrainerView',
        params: {
          id: this.slug,
        },
      })
    }

    this.vcard = vcard
    this.loaded = true

    // Update events
    this.$bus.on('vcard_update.color', async ({ color, color_end }) => {
      await Api.updateVcard(
        _this.slug,
        { vcard_color: color, vcard_color_end: color_end },
        _this.token
      )
      await _this.refreshMe()
    })
  },
  methods: {
    async refreshMe() {
      const token = this.token
      const meData = await Api.me(token)
      const me = meData.data
      const slug = me.slug

      this.me = me
      this.slug = slug

      this.title = me.vcard_title
      this.bio = me.vcard_bio
    },
    async save() {
      this.saving = true
      // await Api.updateVcard(this.slug, data, this.token)
      this.saving = false
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';
@import './ProfileVCard';
@import './ProfileVCardAppearance';
</style>



// WEBPACK FOOTER //
// src/components/ProfileVCardAppearance.vue